<template>
  <div>
    <div class="table-page-search-wrapper">
    <a-form layout='inline' @keyup.enter.native='searchQuery'>
      <a-row :gutter='12'>
<!--        <a-col :md='6' :sm='8'>-->
<!--          <a-form-item :label="$t('platformCollection.name_of_collector')">-->
<!--            &lt;!&ndash;            <a-input :placeholder="$t('enter') + ' 催收员id'" v-model="queryParam.userId"></a-input>&ndash;&gt;-->
<!--            <a-select-->
<!--              v-model='queryParam.userId'-->
<!--              showSearch-->
<!--              allowClear-->
<!--            >-->
<!--              <a-select-option v-for='item in CollectorNameList' :key='item.value' :value='item.value'>-->
<!--                {{ item.key }}-->
<!--              </a-select-option>-->
<!--            </a-select>-->
<!--          </a-form-item>-->
<!--        </a-col>-->
        <a-col :md='6' :sm='8'>
          <a-form-item :label="$t('platformCollection.name_of_collector')">
            <a-input style='width: 200px'
                     placeholder="请输入姓名或账号"
                     v-model="queryParam.userName"/>
          </a-form-item>
        </a-col>
        <a-col :md='6' :sm='8'>
          <a-form-item :label="$t('platformCollection.department')">
            <a-select
              v-model='queryParam.departmentId'
              @change='onChangeOne'
              allowClear
            >
              <a-select-option v-for='item in departmentList' :key='item.id'>
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md='6' :sm='8'>
          <a-form-item :label="$t('platformCollection.grouping')">
            <a-select
              v-model='queryParam.groupId'
              allowClear
            >
              <a-select-option v-for='item in groupList' :key='item.id'>
                {{ item.groupName }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md='6' :sm='8'>
          <a-form-item :label="$t('platformCollection.collection_stage')">
            <a-select
              v-model='queryParam.configId'
              allowClear
            >
              <a-select-option v-for='item in normalConfigList' :key='item.id'>
                {{ item.name }}
              </a-select-option>
            </a-select>
          </a-form-item>
        </a-col>
        <a-col :md='10' :sm='10'>
          <a-form-item :label="$t('platformCollection.date')">
            <a-range-picker
              v-model='queryParam.settleTime'
              format='YYYY-MM-DD'
              style='width: 100%;' />
          </a-form-item>
        </a-col>
        <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
                          <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
                          <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{ $t('reset') }}</a-button>
                          <a-button style='margin-left: 10px;' type='primary' @click="createScheduling('add')"> <a-icon type='plus' />{{ $t('add') }}</a-button>
            </span>
        </a-col>
      </a-row>

      <a-row :gutter='12' style='margin: 20px 0px'>
        <a-col :md='4' :sm='4'>
          <a-upload
            name='file'
            :multiple='true'
            :action="'/api/web/webpublic/collectionUserSchedule/importExcel'"
            :headers='getHeaders()'
            :data='uploadDataParam'
            :openFileDialogOnClick='openFileDialogOnClick'
            @change='handleChangeUpload'
          >
            <a-button type='primary' @click='openupload()' style='margin-left: 8px'>
              <a-icon
                type='upload' />
              上传排班计划
            </a-button>
          </a-upload>
        </a-col>

      </a-row>
    </a-form>
    </div>
    <a-table
      ref='table'
      rowKey='id'
      size='middle'
      :columns='columns'
      :dataSource='dataSource'
      :pagination='false'
      :loading='loading'
      @change='handleTableChange'>

      <span slot='action' slot-scope='text, record' v-show='showEdit(record)'>
          <a @click='createScheduling("edit",record)'>
            {{ $t('edit') }}
          </a>
      </span>
    </a-table>
    <div style='margin-top: 15px; text-align: right;'>
      <v-pagination
        v-if='total'
        :page-num='form.pageNum'
        :page-size='form.pageSize'
        :total='total'
        @change='handleTableChange' />
    </div>
    <a-modal
      :title='modalTitle'
      v-model='visible'
      @ok='submitScheduling'
    >
      <a-form :form='basicForm' :label-col='{ span: 5 }' :wrapper-col='{ span: 18 }'>
        <a-form-item :label="$t('platformCollection.date')">
          <a-date-picker
            v-model='basicForm.date'
            format='YYYY-MM-DD'
            style='width: 100%;'
          />
        </a-form-item>
        <a-form-item :label="$t('platformCollection.department')">
        <a-select
          v-model='basicForm.departmentId'
          @change='onChangeDepartment'
        >
          <a-select-option v-for='item in departmentListFrom' :key='item.id'>
            {{ item.name }}
          </a-select-option>
        </a-select>
        </a-form-item>
        <a-form-item :label="$t('platformCollection.grouping')">
          <a-select
            v-model='basicForm.groupId'
            :options="groupListFrom"
            @change='onChangeGroup'
          >

          </a-select>
        </a-form-item>
        <a-form-item :label="$t('platformCollection.collection_stage')">
          <a-input
            v-model='basicForm.configIdShow'
            read-only
          >
          </a-input>
          <a-input
            v-model='basicForm.configId'
            hidden
          >
          </a-input>
        </a-form-item>
        <a-form-item :label="$t('platformCollection.name_of_collector')">
          <a-select
            v-model='basicForm.userId'
            :options="userIdList"
            optionFilterProp="children"
            showSearch
          >
          </a-select>
        </a-form-item>
        <a-form-item :label="$t('platformCollection.on_duty')">
          <a-switch v-model='basicForm.status' />
        </a-form-item>

      </a-form>
    </a-modal>
    <a-drawer
      :title="$t('platformCollection.management')"
      placement='right'
      :visible='drawerVisible'
      :group-id='currentGroupId'
      width='640'
      @close='closeDrawer'
    >
      <edit-group
        v-if='drawerVisible'
        :group-id='currentGroupId' />
    </a-drawer>
  </div>
</template>


<script>

import { filterObj } from '@/utils/util'
import { getHeaders } from '@/utils/request'
import moment from 'moment'
import vPagination from '../modules/pagination'
import {
  getCollectionUserSchedule,
  getCollectorName,
  insertOrUpdateCollectionScheduling
} from '@/webpublicapi/collection'
import { getSysGroup } from '@/webpublicapi/platformCollection'
import { getAllNormalConfig } from '@/webpublicapi/normalConfig'
import { getCollectionListDepartment } from '@/api/group'
import { getColUserList } from '@/api/system'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}
export default {
  name: 'CollectionUserSchedule',
  components: {
    vPagination
  },
  data() {
    return {
      visible: false,
      drawerVisible: false,
      modalTitle: this.$t('add'),
      currentGroupId: undefined,
      CollectorNameList: [],
      groupList: [],
      departmentList: [],
      normalConfigList: [],
      userIdList: [],
      groupListFrom: [],
      departmentListFrom: [],
      total: 0,
      openFileDialogOnClick: false,
      uploadDataParam: {},
      queryParam: {
        departmentId: undefined, //部门
        groupId: undefined,//组
        groupName: undefined,//组
        configId: undefined,//组
        settleTime: [moment().add( 1,'days',), moment().add( 1,'days')],
        userId: undefined
      },
      dataSource: [],
      loading: false,
      form: {
        pageNum: 1,
        pageSize: 10,
        keywords: undefined,
        groupIdP: ''
      },
      defaultBasicForm: {
        id: undefined,
        date: moment().add(1, 'days'),
        departmentId: undefined,
        groupId: undefined,
        groupIdShow: undefined,
        userId: undefined,
        configId: undefined,
        status: true,
      },
      basicForm: {},
    }
  },
  computed: {
    columns() {
      return [
        {
          title: '催收员',
          align: 'center',
          dataIndex: 'userName'
        },
        {
          title: '催收员账号',
          align: 'center',
          dataIndex: 'loginName'
        },
        {
          title: '催收阶段',
          align: 'center',
          dataIndex: 'configName'
        },
        {
          title: '组名',
          align: 'center',
          dataIndex: 'groupName'
        },
        {
          title: '部门名',
          align: 'center',
          dataIndex: 'departmentName'
        },
        {
          title: '排班时间',
          align: 'center',
          dataIndex: 'date'
        },
        {
          title: '排班状态',
          align: 'center',
          dataIndex: 'status',
          customRender: (text, record, index) => {
            if (text === 1) {
              record.index = index
              return '上班'
            }
            if (text === 0) {
              record.index = index
              return '不上班'
            }
          }
        },
        {
          title: this.$t('action'),
          dataIndex: 'action',
          align: 'center',
          fixed: 'right',
          scopedSlots: { customRender: 'action' }
        }
      ]
    }
  },
  created() {
    // this.getTime()
    this.loadData(1)
    //催收员名称
    getCollectorName().then(res => {
      // this.CollectorNameList = res.data || []
      let keys =  Object.keys(res.data)//拿到所有的key s1test1...
      for (const key of keys) {
        this.CollectorNameList.push({
          key:key,// s1test1
          value:res.data[key] //{s1test1:51}==> res.data[s1test1]==>51
        })

      }
    })
    getSysGroup().then(res => {
      this.groupList = res.data || []
    })
    getCollectionListDepartment().then(res => {
      this.departmentList = res.data || []
      this.departmentListFrom = res.data || []
    })
    getAllNormalConfig().then(res => {
      this.normalConfigList = res.data || []
    })
  },

  methods: {
    openupload() {
      this.openFileDialogOnClick = true
    },
    handleTableChange(pageNum, pageSize) {
      this.form.pageNum = pageNum
      this.form.pageSize = pageSize
      this.search()
    },
    search() {
      this.loading = true
      var params = this.getQueryParams()// 查询条件

      console.log('发请求前的参数', params)
      getCollectionUserSchedule(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    onChangeOne(value) {
      getSysGroup({ 'departmentId': value }).then(res => {
        this.groupList = res.data || []
        this.queryParam.groupId = ''
      })
    },
    onChangeDepartment(value) {

      this.basicForm.groupId = undefined
      this.basicForm.userId = undefined
      this.basicForm.configIdShow = undefined
      this.basicForm.configId = undefined
      this.groupListFrom = []
      this.userIdList = []

      getSysGroup({ 'departmentId': value }).then(res => {
        this.groupListFrom = res.data || []
        if(this.groupListFrom.length === 0 )
          return

        for(let group of this.groupListFrom)
        {
          group.label = group.groupName
          group.value = group.id
        }
      })
    },
    onChangeGroup(value) {
      this.basicForm.configIdShow = undefined
      this.basicForm.configId = undefined
      if(value)
      {
        let configId
        for(let group of this.groupListFrom)
        {
          if(group.value ===  value)
          {
            configId = group.collectionLevel
            break;
          }

        }
        for(let config of this.normalConfigList)
        {
          if(config.id === parseInt(configId))
          {
            this.basicForm.configIdShow = config.name
            this.basicForm.configId = config.id
            break;
          }
        }
      }

      // if(this.departmentListFrom.length === 1)
      //   return

      this.userIdList = []
      this.basicForm.userId = undefined

      let searchFrom = {"pageNum":1,"pageSize":1000,"userstatus":"1"};
      if(this.basicForm.groupId)
        searchFrom.groupIdP = this.basicForm.groupId
      else
        return

      getColUserList(searchFrom).then(res => {
        this.userIdList = res.data ? (res.data.rows || []) : []
        if(this.userIdList.length === 0 )
          return

        for(let user of this.userIdList)
        {
          user.label = user.userName
          user.value = user.id
        }
      })
    },
    getHeaders() {
      return getHeaders()
    },
    clickUploadFile() {

    },
    searchQuery() {
      this.loadData(1)
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    loadData(arg) {
      // 清空选中项
      this.selectedList = []
      this.selectedRowKeys = []
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams()// 查询条件
      console.log('发请求前的参数', params)
      getCollectionUserSchedule(Object.assign({}, params)).then((res) => {
        if (res.code === 1000) {
          this.total = res.data.total
          this.dataSource = res.data.list
        } else {
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
        this.loading = false
        this.$message.error(e.message)
      })
    },
    getQueryParams() {
      const { settleTime } = this.queryParam

      const data = {
        ...this.queryParam,//...将原始的this.queryParam对象中的属性复制到data对象中
        beginDate: (settleTime && settleTime.length) ? this.transformTime(settleTime[0]) : undefined,
        endDate: (settleTime && settleTime.length) ? this.transformTime(settleTime[1]) : undefined
        //根据条件判断，将settleTime数组中的第一个元素和第二个元素通过transformTime方法转换后赋值给data对象的beginDate和endDate属性。
      }

      let param = this.queryParam

      for (const group of this.groupList) {
        if(group.id === param.groupId)
          param.groupName = group.groupName;
      }

      param = Object.assign(data)
      param.pageNum = this.form.pageNum
      param.pageSize = this.form.pageSize

      return filterObj(param)
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.userId = undefined
      that.queryParam.departmentId = undefined
      that.queryParam.groupId = undefined
      that.queryParam.endDate = ''
      that.queryParam.beginDate = ''
      that.queryParam.settleTime = []

      // that.loadData(this.form.pageNum)
    },
    handleToggleSearch() {
      this.toggleSearchStatus = !this.toggleSearchStatus
    },
    handleChangeUpload(info) {
      console.log(info)
      //debugger;
      if (info.file.status !== 'uploading') {
        console.log(info.file, info.fileList)
        console.log(1)
      }
      if (info.file.status === 'done') {
        console.log('上传成功！')
        if (info.file.response.code === 1000) {
          //alert('handle success!');
          this.$message.success(`${info.file.name} file uploaded successfully`)
        } else {
          alert(info.file.response.msg)
        }
      } else if (info.file.status === 'error') {
        console.log(3)
        //this.$message.error(`${info.file.name} file upload failed.`);
        alert('system error!')
      }
      // }
      console.log('准备刷新页面！')
      this.loadData(1)
      console.log('页面刷新成功！')
    },
    createScheduling(mode, record = {}) {
      this.changeModal(true)
      this.basicForm.id = record.id
      if (mode == 'edit') {

        this.departmentListFrom = [{id:record.departmentId,name:record.departmentName}]
        this.userIdList = [{label:record.userName,value:record.userId}]
        this.groupListFrom = [{label:record.groupName,value:record.groupId}]

        this.basicForm = {
          ...this.basicForm,
          departmentId: record.departmentId,
          groupId: record.groupId,
          configId: record.configId,
          configIdShow: record.configName,
          userId: record.userId,
          status: record.status == 1,
          date: moment(new Date(record.date)),
        }

        let searchFrom = {"pageNum":1,"pageSize":1000,"userId":record.userId};

        getColUserList(searchFrom).then(res => {
          let userList = res.data ? (res.data.rows || []) : []
          if(userList.length && userList[0].groups && userList[0].groups.length)
          {
            for(let group of userList[0].groups)
            {
              group.label = group.groupName
              group.value = group.id
            }
            this.groupListFrom = userList[0].groups
          }
        })

        this.basicForm.userId = record.userId

      } else {
        this.basicForm = { ...this.defaultBasicForm }
        this.departmentListFrom = this.departmentList
        this.groupListFrom = []
        this.userIdList = []
      }
      this.modalTitle = mode == 'add' ? this.$t('add') : this.$t('edit')
    },
    submitScheduling() {
      this.changeModal(false)
      this.loading = true
      const form = {
        ...this.basicForm,
        status: this.basicForm.status ? 1 : 0,
        dateStr: (this.basicForm.date) ? this.transformTime(this.basicForm.date) : undefined,
        date : undefined,
      }

      for(let group of this.groupListFrom)
      {
        if(group.id === form.groupId)
        {
          form.groupName = group.groupName
          break;
        }
      }

      insertOrUpdateCollectionScheduling(form).then(res => {
        if(res.code && res.code !== 1000)
        {
          this.$message.error(res.msg)
          return
        }
        this.loading = false
        this.$message.success(this.$t('success'))
        this.search(1)
      }).catch(e => {
        this.$message.error(e.message)
      })
    },
    showEdit(record)
    {
      let momentStr = moment().format('YYYY-MM-DD')
      const momentDate = new Date(momentStr);
      const inputDate = new Date(record.date);

      return inputDate && inputDate > momentDate;
    },
    closeDrawer() {
      this.drawerVisible = false
    },
    changeModal(visible) {
      this.visible = visible
    },
  }
}
</script>

<style lang='less' scoped>
@import "~@/assets/less/common.less";
</style>